import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-metric-card',
  standalone: true,
  imports: [RouterLink, LucideAngularModule],
  template: `
    <article class="metric-card">
      <div class="metric-header">
        <p class="metric-title">{{ title() }}</p>
        @if (icon()) {
          <lucide-icon [name]="icon()!" class="metric-icon"></lucide-icon>
        }
      </div>

      <p class="metric-value">{{ value() }}</p>
      <p class="metric-description">{{ description() }}</p>

      @if (link()) {
        <a [routerLink]="link()" class="metric-link">Ver detalhes</a>
      }
    </article>
  `,
  styles: [
    `
      .metric-card {
        border: 1px solid var(--border);
        border-radius: 14px;
        background: var(--surface-elevated);
        padding: 16px;
        box-shadow: var(--shadow-card);
      }

      .metric-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .metric-title {
        font-size: 14px;
        font-weight: 600;
        color: var(--muted);
      }

      .metric-value {
        font-size: 32px;
        font-weight: 700;
        color: var(--text);
        margin-top: 8px;
      }

      .metric-description {
        margin-top: 4px;
        font-size: 13px;
        color: var(--muted);
      }

      .metric-link {
        display: inline-block;
        margin-top: 12px;
        font-size: 13px;
        color: var(--active-text);
        text-decoration: none;
      }

      .metric-link:hover {
        text-decoration: underline;
      }

      .metric-icon {
        width: 16px;
        height: 16px;
        color: var(--muted);
      }
    `,
  ],
})
export class MetricCardComponent {
  readonly title = input.required<string>();
  readonly value = input.required<string>();
  readonly description = input.required<string>();
  readonly icon = input<string | null>(null);
  readonly link = input<string | null>(null);
}
